import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

// Import de tus componentes de ejemplo
import InputLogin from '../../../inputs/InputLogin';
import ButtonWhite from '../../../button/ButtonWhite';
import ButtonBack from '../../../button/ButtonBack';
import SearchableSelect from '../../../select/SearchableSelect';
import SelectDocument from '../../../select/selectDocument';
import ButtonCheckBoxLabel from '../../../button/ButtonCheckBoxLabel'
import ButtonSelect from "../../../button/ButtonSelect"
// Ejemplo de uso de la función: 
// const createAccountBank = ({ 
//   nombres, setNombres,
//   apellidos, setApellidos,
//   documento, setDocumento,
//   tipoDocumento, setTipoDocumento,
//   banco, setBanco,
//   numeroCuenta, setNumeroCuenta,
//   numeroRuta, setNumeroRuta,
//   tipoCuenta, setTipoCuenta,
//   nombreCuenta, setNombreCuenta,
//   ...
// }) => {...}

const CreateAccountBank = ({
    selectMethod,
    // Ejemplo de props para que recibas el get y set desde afuera
    nombres,
    listaBancosEEUU,
    errorADDBank,
    setNombres,
    apellidos,
    setApellidos,
    tipoDocumento,
    setTipoDocumento,
    documento,
    setDocumento,
    bancoSeleccionado,
    setBancoSeleccionado,
    listaBancos,      // Para SearchableSelect
    errorBanco,       // Si quieres manejar algún error
    numeroCuenta,
    setNumeroCuenta,
    currency,
    tipoCuenta,
    setTipoCuenta,
    AccountCountry,
    setAccountCountry,
    wire,
    setWire,
    rountingNum,
    setRountingNum


}) => {

    useEffect(() => {
        // Esta función se ejecutará cuando el componente se desmonte
        return () => {
            if (setNombres) setNombres('');
            if (setApellidos) setApellidos('');
            if (setTipoDocumento) setTipoDocumento(0);
            if (setDocumento) setDocumento('');
            if (setBancoSeleccionado) setBancoSeleccionado(null);
            if (setNumeroCuenta) setNumeroCuenta('');
            if (setTipoCuenta) setTipoCuenta(null);
            if (setAccountCountry) setAccountCountry(null);
            if (setWire) setWire('');
            if (setRountingNum) setRountingNum('');
        };
    }, []); // El array de dependencias vacío asegura que el efecto solo se ejecute en montaje y desmontaje.

    // Aquí un estado local para manejar la selección del "Banco Nacional" vs "Banco Internacional"
    const [isBancoInternacional, setIsBancoInternacional] = useState(false);

    // Manejador del toggle entre Banco Nacional / Internacional
    const handleToggleBanco = (valor) => {
        setIsBancoInternacional(valor);
    };

    // Manejador de tipos de cuenta (Ahorros / Corriente)
    // Como no existe componente, lo hacemos con botones normales
    const handleTipoCuenta = (tipo) => {
        setTipoCuenta(tipo);
    };

    const bankAccountTypeList_usd = [
        { label: 'Cuenta de Ahorro', value: 'SAVINGS' },
        { label: 'Cuenta Corriente', value: 'CHECKING' },
        { label: 'Cuenta empresarial', value: 'BUSINESS' },
    ];


    if (currency === 'USD' && (selectMethod === 'venmo' || selectMethod === 'paypal')) {
        return (
            <div className="w-full h-full mt-5 flex flex-col gap-2">
                <p className="text-sm text-left text-[#8A8A8E] mb-2">
                    {selectMethod === 'paypal' ? 'Ingrese su usuario Paypal' : 'Ingrese su usuario Venmo'}
                </p>
                <InputLogin
                    placeholder={selectMethod === 'paypal' ? 'correo@gmail.com' : 'usuario'}
                    value={nombres}
                    onChange={(e) => setNombres(e)}
                />
                {errorADDBank &&
                    <p className='text-[14px] text-center text-[#e4847f] mt-2'>{errorADDBank}</p>
                }
            </div>
        )
    }

    if (currency === 'USD' && selectMethod === 'banco') {
        return (
            <div className="w-full h-full mt-5 flex flex-col gap-4">
                <InputLogin
                    placeholder="Nombre completo del titular"
                    value={nombres}
                    onChange={(e) => setNombres(e)}
                />
                <InputLogin
                    placeholder="Número de cuenta"
                    value={numeroCuenta}
                    onChange={(e) => setNumeroCuenta(e)}
                />
                <InputLogin
                    placeholder="Número de ruta (Routing)"
                    value={rountingNum}
                    onChange={(e) => setRountingNum(e)}
                />

                <p className="text-sm text-[#8A8A8E] -mb-2 text-left">Tipo de cuenta</p>
                <div className='flex flex-row gap-2 flex-wrap'>
                    {bankAccountTypeList_usd.map((accountType) => (
                        <button
                            key={accountType.value}
                            onClick={() => setTipoCuenta(accountType.value)}
                            className={`py-2 px-4 rounded-lg text-sm font-medium transition-colors ${tipoCuenta === accountType.value ? 'bg-white text-black' : 'bg-[#3C3C43] hover:bg-[#4a4a52] text-white'}`}
                        >
                            {accountType.label}
                        </button>
                    ))}
                </div>

                {errorADDBank &&
                    <p className='text-[14px] text-center text-[#e4847f]'>{errorADDBank}</p>
                }
            </div>
        )
    }

    return (
        <div className="w-full h-full mt-5 flex flex-col gap-4">

            {/* Toggle Banco Nacional / Banco Internacional */}



            {/* Quién recibe: Nombres y Apellidos */}
            <div className="flex flex-col md:flex-row gap-3">
                <InputLogin
                    placeholder="Nombres"
                    value={nombres}
                    onChange={(e) => setNombres(e)}
                />
                <InputLogin
                    placeholder="Apellidos"
                    value={apellidos}
                    onChange={(e) => setApellidos(e)}
                />
            </div>

            {/* Documento de identidad */}
            <div className="flex flex-col md:flex-row gap-3">
                <SelectDocument
                    type="id"
                    value={tipoDocumento}
                    setValue={setTipoDocumento}
                // Si quieres manejar varias opciones, defínelas o pásalas por props
                // Ejemplo de opciones: "CC", "CE", "NIT", etc.
                />
                <InputLogin
                    placeholder="Número de identidad"
                    value={documento}
                    onChange={(e) => setDocumento(e)}
                />
            </div>


            {/* Banco (select) */}
            <SearchableSelect
                setSelectOpcion={setBancoSeleccionado}
                list={currency === "COP" ? listaBancos : listaBancosEEUU}
                error={errorBanco}
                label={bancoSeleccionado === null ? "Selecciona un banco" : bancoSeleccionado}
            />

            {/* Número de cuenta */}
            <InputLogin
                error={errorADDBank}
                placeholder="Ingrese el número de cuenta"
                value={numeroCuenta}
                onChange={(e) => setNumeroCuenta(e)}
            />
            {currency === "USD" && <InputLogin

                placeholder="Número de ruta"
                value={rountingNum}
                onChange={(e) => setRountingNum(e)}
            />}
            {currency === "USD" && <InputLogin

                placeholder="Wire"
                value={wire}
                onChange={(e) => setWire(e)}
            />}


            {/* Número de ruta */}


            {/* Tipo de cuenta: Ahorros / Corriente */}
            <div className='flex flex-row gap-2'>
                <ButtonCheckBoxLabel tipoCuenta={tipoCuenta} onClick={handleTipoCuenta} label={currency === "USD" ? "Saving" : "Ahorros"} />
                <ButtonCheckBoxLabel tipoCuenta={tipoCuenta} onClick={handleTipoCuenta} label={currency === "USD" ? "checking" : "Corriente"} />
            </div>

            {errorADDBank &&
                <p className='text-[14px] text-center text-[#e4847f]'>{errorADDBank}</p>

            }

        </div>
    );
};

export default CreateAccountBank;
